// Async import so Module Federation's shared-scope negotiation (see
// rspack.config.ts) finishes before any app code (including a future
// remote's) runs — the standard MF host entry-point pattern.
import("./bootstrap");
